import React, {Component} from 'react';
import {connect} from 'react-redux';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import InvoiceDetailModel from '../../models/InvoiceDetail';
import PropTypes from 'prop-types';
import {amountFormatter, payerFormatter, reasonFormatter, soldToFormatter} from '../../common/invoiceHelpers';
import {FormattedDate, FormattedMessage} from "react-intl";
import {trimLeadingZeroes} from "../../utils";
import {getSelectedPaymentOption} from "./Selectors";
import {extractLastCardNumbers} from "../../actions/InvoiceActions";
import Logo from "../Logo";

class PaymentStatus extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const statuses = this.props.paymentStatuses;
    const paymentStatus = statuses && statuses.length > 0 ? statuses[0] : null;
    const success = paymentStatus && paymentStatus.message_type === 'S';
    const alertClass = success ? 'alert alert-success' : 'alert alert-danger';
    const status = paymentStatus && paymentStatus.message_type ? paymentStatus.message_line_string : '';
    const documentNumber = paymentStatus && paymentStatus.document_number_finance ? paymentStatus.document_number_finance : '';
    const referenceCode = paymentStatus && paymentStatus.authorization_reference_code ? paymentStatus.authorization_reference_code : '';
    const top = 'Top';

    let invoices = Object.keys(this.props.invoices).map((key) => {
      let invoice = this.props.invoices[key];
      let details = this.props.details[key];
      return {
        billing_document_number: invoice.billing_document_number,
        document_number_finance: invoice.document_number_finance,
        open_amount: invoice.open_amount,
        amount_to_process: success ? details.amount : '',
        sold_to: invoice.soldto_number,
        payer: invoice.payer_number,
        currency_key: invoice.currency_key,
        reason: this.props.cnbsConfig.payment_reason_codes.find(r => r.reason_code === details.reason),
        reason_message: details.comment,
        zzcustom: invoice.zzcustom,
      };
    });

    return (
      <div>
        <div className={alertClass}>
          <div className="d-none d-print-block float-right"><Logo/></div>
          <strong>Status: </strong> {status} <br/>
          <strong><FormattedMessage
            id={"payment_status.document_number"}/>:</strong> {documentNumber.replace(/^0+/, '')}
          <br/>
          <strong><FormattedMessage id={"payment_status.reference_code"}/>:</strong> {referenceCode.replace(/^0+/, '')}
          <br/>
          {this.props.paymentCard &&
          <React.Fragment><strong><FormattedMessage id={"payment_status.payment_method_label"}/>: </strong>
            <FormattedMessage
              id={"payment_status.payment_method"}
              values={{
                type: this.props.paymentCard.payment_card_type,
                numbers: extractLastCardNumbers(this.props.paymentCard.payment_card_token, '-')
              }}
            /></React.Fragment>} <br/>
          <strong><FormattedMessage id={"payment_status.processed_by"}/>:</strong> {this.props.currentUser.Login} <br/>
          <strong><FormattedMessage id={"payment_status.processed_date"}/>:</strong> <FormattedDate value={Date.now()}/>
        </div>
        <br/>
        <div>
          <BootstrapTable data={invoices} scrollTop={top} tableHeaderClass="payment-status-header">
            <TableHeaderColumn width="65" className="headerColumnColor" headerAlign="center" dataAlign="center"
                               dataField="billing_document_number" isKey dataFormat={trimLeadingZeroes}>
              <FormattedMessage id={"payment_status.table.document_number_header"}/>
            </TableHeaderColumn>
            <TableHeaderColumn width="55" className="headerColumnColor" headerAlign="center" dataAlign="right"
                               dataField="open_amount" dataFormat={amountFormatter}>
              <FormattedMessage id={"payment_status.table.invoice_amount_header"}/>
            </TableHeaderColumn>
            <TableHeaderColumn width="55" className="headerColumnColor" headerAlign="center" dataAlign="right"
                               dataField="amount_to_process" dataFormat={amountFormatter}>
              <FormattedMessage id={"payment_status.table.paid_header"}/>
            </TableHeaderColumn>
            <TableHeaderColumn width="90px" className="headerColumnColor" headerAlign="center"
                               dataField="sold_to" dataFormat={soldToFormatter}>
              <FormattedMessage id={"payment_status.table.sold_to_header"}/>
            </TableHeaderColumn>
            <TableHeaderColumn width="90px" className="headerColumnColor" headerAlign="center"
                               dataField="payer" dataFormat={payerFormatter}>
              <FormattedMessage id={"payment_status.table.payer_header"}/>
            </TableHeaderColumn>
            <TableHeaderColumn width="90px" className="headerColumnColor" headerAlign="center"
                               dataField="payer" dataFormat={reasonFormatter}>
              <FormattedMessage id={"payment_status.table.partial_payment"}/>
            </TableHeaderColumn>
          </BootstrapTable>
          <div className={"row d-print-none"}>
            <div className={"col-4"}>
              <p className={"mt-2"}><FormattedMessage id={"payment_status.message"}/>
              </p>
              <button className={"btn btn-primary"} onClick={() => window.print()}>Print</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PaymentStatus.propTypes = {
  selectedInvoices: PropTypes.arrayOf(PropTypes.instanceOf(InvoiceDetailModel)).isRequired,
};

export default connect((store, props) => ({
  paymentStatuses: store.default.paymentStatuses,
  invoices: store.invoice.completed.invoices,
  details: store.invoice.completed.details,
  paymentCard: getSelectedPaymentOption(store, props),
  currentUser: store.default.currentUser,
  cnbsConfig: store.app.cnbsConfig,
}))(PaymentStatus);
